import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-dark-100 text-text-dark/50 py-12 px-6 border-t border-white/5" data-id="element-40">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-41">
        <p className="font-serif text-xl text-text-dark/80" data-id="element-42">
          S.O.S. Sueño Infantil
        </p>

        <p className="text-sm max-w-2xl mx-auto" data-id="element-43">
          Descargo de responsabilidad: Los resultados pueden variar. Este ebook
          proporciona pautas generales y no sustituye el consejo médico
          profesional. Si tu bebé tiene problemas de salud, consulta siempre con
          su pediatra.
        </p>

        <div className="pt-6 border-t border-white/5 text-sm" data-id="element-44">
          &copy; {currentYear} S.O.S. Sueño Infantil. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}